// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HotelRevenueManagementInMysorePage from "../pages/HotelRevenueManagementInMysore/HotelRevenueManagementInMysore";
const __wvcRoutePaths = ["/HotelRevenueManagementInMysorePage", "/hotel-revenue-management-in-mysore"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about-sunil", "aboutpage", "case-studies", "casestudiespage", "client-portal-preview", "clientportalpreviewpage", "contact", "contactpage", "glossary-of-hospitality-revenue-management", "glossaryofhospitalityrevenuemanagementpage", "home", "homepage", "hotel-revenue-management-in-agra", "hotel-revenue-management-in-ahmedabad", "hotel-revenue-management-in-alibag", "hotel-revenue-management-in-amritsar", "hotel-revenue-management-in-bangalore", "hotel-revenue-management-in-chandigarh", "hotel-revenue-management-in-chennai", "hotel-revenue-management-in-darjeeling", "hotel-revenue-management-in-dehradun", "hotel-revenue-management-in-delhi", "hotel-revenue-management-in-digha", "hotel-revenue-management-in-dwarka", "hotel-revenue-management-in-goa", "hotel-revenue-management-in-gulmarg", "hotel-revenue-management-in-gurgaon", "hotel-revenue-management-in-haridwar", "hotel-revenue-management-in-hyderabad", "hotel-revenue-management-in-indore", "hotel-revenue-management-in-jaipur", "hotel-revenue-management-in-jodhpur", "hotel-revenue-management-in-kolkata", "hotel-revenue-management-in-lonavala", "hotel-revenue-management-in-lucknow", "hotel-revenue-management-in-madurai", "hotel-revenue-management-in-mahabaleshwar", "hotel-revenue-management-in-manali", "hotel-revenue-management-in-matheran", "hotel-revenue-management-in-mount-abu", "hotel-revenue-management-in-mumbai", "hotel-revenue-management-in-munnar", "hotel-revenue-management-in-mussoorie", "hotel-revenue-management-in-mysore", "hotel-revenue-management-in-nainital", "hotel-revenue-management-in-ooty", "hotel-revenue-management-in-pondicherry", "hotel-revenue-management-in-pune", "hotel-revenue-management-in-puri", "hotel-revenue-management-in-rishikesh", "hotel-revenue-management-in-shimla", "hotel-revenue-management-in-shirdi", "hotel-revenue-management-in-srinagar", "hotel-revenue-management-in-tirupati", "hotel-revenue-management-in-udaipur", "hotel-revenue-management-in-ujjain", "hotel-revenue-management-in-varanasi", "hotel-revenue-management-in-vrindavan", "hotelrevenuemanagementinagrapage", "hotelrevenuemanagementinahmedabadpage", "hotelrevenuemanagementinalibagpage", "hotelrevenuemanagementinamritsarpage", "hotelrevenuemanagementinbangalorepage", "hotelrevenuemanagementinchandigarhpage", "hotelrevenuemanagementinchennaipage", "hotelrevenuemanagementindarjeelingpage", "hotelrevenuemanagementindehradunpage", "hotelrevenuemanagementindelhipage", "hotelrevenuemanagementindighapage", "hotelrevenuemanagementindwarkapage", "hotelrevenuemanagementingoapage", "hotelrevenuemanagementingulmargpage", "hotelrevenuemanagementingurgaonpage", "hotelrevenuemanagementinharidwarpage", "hotelrevenuemanagementinhyderabadpage", "hotelrevenuemanagementinindorepage", "hotelrevenuemanagementinjaipurpage", "hotelrevenuemanagementinjodhpurpage", "hotelrevenuemanagementinkolkatapage", "hotelrevenuemanagementinlonavalapage", "hotelrevenuemanagementinlucknowpage", "hotelrevenuemanagementinmaduraipage", "hotelrevenuemanagementinmahabaleshwarpage", "hotelrevenuemanagementinmanalipage", "hotelrevenuemanagementinmatheranpage", "hotelrevenuemanagementinmountabupage", "hotelrevenuemanagementinmumbaipage", "hotelrevenuemanagementinmunnarpage", "hotelrevenuemanagementinmussooriepage", "hotelrevenuemanagementinmysorepage", "hotelrevenuemanagementinnainitalpage", "hotelrevenuemanagementinootypage", "hotelrevenuemanagementinpondicherrypage", "hotelrevenuemanagementinpunepage", "hotelrevenuemanagementinpuripage", "hotelrevenuemanagementinrishikeshpage", "hotelrevenuemanagementinshimlapage", "hotelrevenuemanagementinshirdipage", "hotelrevenuemanagementinsrinagarpage", "hotelrevenuemanagementintirupatipage", "hotelrevenuemanagementinudaipurpage", "hotelrevenuemanagementinujjainpage", "hotelrevenuemanagementinvaranasipage", "hotelrevenuemanagementinvrindavanpage", "insights", "insightspage", "knowledge-hub", "knowledgehubpage", "locations", "locationspage", "post", "revenue-calculator", "revenuecalculatorpage", "search", "services", "servicespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<HotelRevenueManagementInMysorePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<HotelRevenueManagementInMysorePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
